import "./App.scss";
import Counter from "./Components/Counter";

function App() {
  return (
    <div className="App">
      <h1>
        <em>H</em>
        .I.I.T
      </h1>
      <Counter />
    </div>
  );
}

export default App;
